import React from 'react';
import { Link } from 'react-router-dom';

export default function Footer() {
	return (
		<footer className="fixed bottom-0 w-[1060px] flex flex-row justify-around items-center h-[30px] bg-[#424274] text-white">
      <div>&#169; 2025 by PerCentage Corporation</div>
			<Link
					to='#'
					onClick={(e) => {
							window.location.href = "mailto:mismo@percentage.net";
							e.preventDefault();
					}}
			>
				Contact EMail
			</Link>			
		</footer>
	)
}
